const ActionButtons = ({ onCheck, onReset, showCheck = true }) => (
  <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 mt-4 sm:mt-6 justify-center">
    {showCheck && (
      <button
        onClick={onCheck}
        className="bg-gradient-to-r from-teal-500 to-teal-600 text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-xl font-bold hover:scale-105 transition-all shadow-lg"
      >
        تحقق من الإجابة
      </button>
    )}
    <button
      onClick={onReset}
      className="bg-gradient-to-r from-red-400 to-red-500 text-white px-6 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-xl font-bold hover:scale-105 transition-all shadow-lg"
    >
      {showCheck ? 'إعادة المحاولة' : 'مسح الألوان'}
    </button>
  </div>
);

export default ActionButtons;